



























import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {Beneficiary, MemberPlan} from "@/models/MemberPlan";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";

@Component({
  components: {}
})
export default class MemberBeneficiariesItem extends AfterFetchComponent {

  @Prop() memberPlan!: MemberPlan;


  columns: GridColumn[] = [];
  errorMessage: string = ""

  mounted() {
    if (this.memberPlan && this.memberPlan.beneficiariesList.length > 0) {
      this.initColumns();
      this.bindGridData(this.memberPlan.beneficiariesList)
    } else if (this.memberPlan) {
      this.errorMessage = this.memberPlan.errorMessage
    }
  }


  initColumns(): void {
    this.columns.push({property: 'firstName', header: 'MemberBeneficiaries.firstName'} as GridColumn);
    this.columns.push({property: 'lastName', header: 'MemberBeneficiaries.lastName'} as GridColumn);
    this.columns.push({property: 'birthDate', header: 'MemberBeneficiaries.dateOfBirth'} as GridColumn);
    this.columns.push({property: 'idNumber', header: 'MemberBeneficiaries.identityOrPassportNumber'} as GridColumn);
    this.columns.push({property: 'updatedDate', header: 'MemberBeneficiaries.updatedDate'} as GridColumn);
    this.columns.push({property: 'relationship', header: 'MemberBeneficiaries.familyRelationship'} as GridColumn);
    this.columns.push({property: 'percentage', header: 'MemberBeneficiaries.shareInPercentages'} as GridColumn);
  }


  bindGridData(beneficiariesList: Beneficiary[]) {

    const data = {
      hasMore: false,
      resultCount: beneficiariesList.length,
      results: beneficiariesList
    }

    this.$emit('successResults', data)
  }
}
